export var IntelligentPhotoCaptureAssignmentSummaryStatus;
(function (IntelligentPhotoCaptureAssignmentSummaryStatus) {
    IntelligentPhotoCaptureAssignmentSummaryStatus["COPY"] = "Copy";
    IntelligentPhotoCaptureAssignmentSummaryStatus["DELETE"] = "Delete";
    IntelligentPhotoCaptureAssignmentSummaryStatus["MOVE"] = "Move";
    IntelligentPhotoCaptureAssignmentSummaryStatus["REPLACE"] = "Replace";
    IntelligentPhotoCaptureAssignmentSummaryStatus["RETAKE"] = "Retake";
    IntelligentPhotoCaptureAssignmentSummaryStatus["SUBMIT"] = "Submit";
})(IntelligentPhotoCaptureAssignmentSummaryStatus || (IntelligentPhotoCaptureAssignmentSummaryStatus = {}));
//# sourceMappingURL=IntelligentPhotoCaptureAssignmentSummaryStatus.js.map